import React from "react";
import { type Mode, type Theme } from "~/features/ui/get-theme-style";
type Props = {
  theme: Theme;
  mode: Mode;
};
export const ChipEvolutionGraphBlockContext = React.createContext<Props | undefined>(undefined);
export const useChipEvolutionGraphBlock = () => {
  const context = React.useContext(ChipEvolutionGraphBlockContext);
  if (context === undefined) {
    throw new Error("useChipEvolutionGraphBlock must be used within a ChipEvolutionGraphBlockProvider");
  }
  return context;
};